// import React from "react";
// import {
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody
// } from "@mui/material";
// import { motion } from "framer-motion";
// import dayjs from "dayjs";
// import getData from "../Webservice/Webservice";

// export default function OutOfStockProducts() {

//   // 🔹 Sample Data
//   const outOfStockProducts = [
//     {
//       _id: "6900945c9b069f89c203839c",
//       productCode: "PRDD4UZSH7Z9V",
//       title: "Towel XL",
//       ownership: "Own Product",
//       availableQuantity: 0,
//       minimumStockQuantity: 10,
//       isFree: true,
//       updatedAt: "2025-11-03T13:07:30.587Z"
//     },
//     {
//       _id: "6900980a9b069f89c203849f",
//       productCode: "PRDVYWEI9DLJK",
//       title: "Saving brush",
//       ownership: "Own Product",
//       availableQuantity: 0,
//       minimumStockQuantity: 20,
//       isFree: false,
//       updatedAt: "2025-10-28T10:51:27.866Z"
//     },
//     {
//       _id: "68e64dab86ea1f8759e2b375",
//       title: "wood comb",
//       ownership: "Vendor Product",
//       availableQuantity: 0,
//       minimumStockQuantity: 123,
//       isFree: false,
//       updatedAt: "2025-10-14T07:37:39.620Z"
//     },
//     {
//       _id: "68959a227e8a78c4bfe3cecb",
//       title: "Hair growth serum",
//       ownership: "Vendor Product",
//       availableQuantity: -52,
//       minimumStockQuantity: 22,
//       updatedAt: "2025-10-10T09:59:04.081Z",
//       isFree: false
//     }
//   ];

//   return (
//     <Paper
//       component={motion.div}
//       elevation={3}
//       sx={{
//         borderRadius: 4,
//         p: 3,
//         background: "linear-gradient(135deg, #f9fafb, #ffffff)",
//         mt: 3
//       }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 3
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{
//             fontWeight: 700,
//             textAlign: "center",
//             color: "text.primary",
//             fontFamily: "Mulish, sans-serif"
//           }}
//         >
//           Out of Stock Products
//         </Typography>

//         <Typography variant="body2" sx={{ color: "text.secondary" }}>
//           {outOfStockProducts.length} items need restocking
//         </Typography>
//       </Box>

//       {/* Table */}
//       <Table>
//         <TableHead>
//           <TableRow sx={{ backgroundColor: "#f4f6f8" }}>
//             <TableCell sx={{ fontWeight: 600 }}>Product Title</TableCell>
//             {/* <TableCell sx={{ fontWeight: 600 }}>Ownership</TableCell> */}
//             <TableCell sx={{ fontWeight: 600 }}>Available</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Min. Required</TableCell>
//             {/* <TableCell sx={{ fontWeight: 600 }}>Free</TableCell> */}
//             {/* <TableCell sx={{ fontWeight: 600 }}>Last Updated</TableCell> */}
//           </TableRow>
//         </TableHead>

//         <TableBody>
//           {outOfStockProducts.map(product =>
//             <TableRow key={product._id}>
//               <TableCell sx={{ fontWeight: 600, color: "#000000ff" }}>
//                 {product.title}
//                 <Typography sx={{ fontSize: "11px", color: "text.secondary" }}>
//                   Last Updated:{dayjs(product.updatedAt).format("DD MMM, YYYY")}
//                 </Typography>
//               </TableCell>

//               {/* <TableCell>
//                 <Chip
//                   label={product.ownership}
//                   color={
//                     product.ownership === "Own Product"
//                       ? "primary"
//                       : "secondary"
//                   }
//                   size="small"
//                   sx={{ textTransform: "capitalize" }}
//                 />
//               </TableCell> */}

//               <TableCell sx={{ color: "#dc2626", fontWeight: 600 }}>
//                 {product.availableQuantity}
//               </TableCell>

//               <TableCell sx={{ color: "#f59e0b", fontWeight: 600 }}>
//                 {product.minimumStockQuantity}
//               </TableCell>

//               {/* <TableCell>
//                 <Chip
//                   label={product.isFree ? "Yes" : "No"}
//                   color={product.isFree ? "success" : "default"}
//                   size="small"
//                 />
//               </TableCell> */}

//               {/* <TableCell sx={{ color: "text.secondary" }}>
//                 {dayjs(product.updatedAt).format("DD MMM, YYYY")}
//               </TableCell> */}
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>
//     </Paper>
//   );
// }

import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Alert
} from "@mui/material";
import { motion } from "framer-motion";
import dayjs from "dayjs";
import { getData } from "../Webservice/Webservice";

export default function OutOfStockProducts() {
  const [outOfStockData, setOutOfStockData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOutOfStockProducts = async () => {
      try {
        setLoading(true);
        setError(null);
        const tokenValue = sessionStorage.getItem("token");
        const token = tokenValue ? `Bearer ${tokenValue}` : "";
        const data = await getData("dashboard/out-of-stock", null, token);

        if (data && data.success && data.outOfStockProducts) {
          setOutOfStockData(data);
        } else {
          throw new Error("Invalid out of stock products response format");
        }
      } catch (err) {
        setError(err.message || "Failed to load out of stock products");
      } finally {
        setLoading(false);
      }
    };

    fetchOutOfStockProducts();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <Paper
        component={motion.div}
        elevation={3}
        sx={{
          borderRadius: 4,
          p: 3,
          background: "linear-gradient(135deg, #f9fafb, #ffffff)",
          mt: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 400
        }}
      >
        <CircularProgress />
      </Paper>
    );
  }

  // Show error state
  if (error) {
    return (
      <Paper
        component={motion.div}
        elevation={3}
        sx={{
          borderRadius: 4,
          p: 3,
          background: "linear-gradient(135deg, #f9fafb, #ffffff)",
          mt: 3
        }}
      >
        <Alert severity="error">
          {error}
        </Alert>
      </Paper>
    );
  }

  // Show data when available
  if (!outOfStockData) {
    return null;
  }

  const { outOfStockProducts, totalCount } = outOfStockData;

  return (
    <Paper
      component={motion.div}
      elevation={3}
      sx={{
        borderRadius: 4,
        p: 3,
        background: "linear-gradient(135deg, #f9fafb, #ffffff)",
        mt: 3
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            textAlign: "center",
            color: "text.primary",
            fontFamily: "Mulish, sans-serif"
          }}
        >
          Out of Stock Products
        </Typography>

        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {totalCount} items need restocking
        </Typography>
      </Box>

      {/* Table */}
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f4f6f8" }}>
            <TableCell sx={{ fontWeight: 600 }}>Product Title</TableCell>
            {/* <TableCell sx={{ fontWeight: 600 }}>Ownership</TableCell> */}
            <TableCell sx={{ fontWeight: 600 }}>Available</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Min. Required</TableCell>
            {/* <TableCell sx={{ fontWeight: 600 }}>Free</TableCell> */}
            {/* <TableCell sx={{ fontWeight: 600 }}>Last Updated</TableCell> */}
          </TableRow>
        </TableHead>

        <TableBody>
          {outOfStockProducts.map(product =>
            <TableRow key={product._id}>
              <TableCell sx={{ fontWeight: 600, color: "#000000ff" }}>
                {product.title}
                <Typography sx={{ fontSize: "11px", color: "text.secondary" }}>
                  Last Updated:{" "}
                  {dayjs(product.updatedAt).format("DD MMM, YYYY")}
                </Typography>
              </TableCell>

              {/* <TableCell>
                <Chip
                  label={product.ownership}
                  color={
                    product.ownership === "Own Product"
                      ? "primary"
                      : "secondary"
                  }
                  size="small"
                  sx={{ textTransform: "capitalize" }}
                />
              </TableCell> */}

              <TableCell sx={{ color: "#dc2626", fontWeight: 600 }}>
                {product.availableQuantity}
              </TableCell>

              <TableCell sx={{ color: "#f59e0b", fontWeight: 600 }}>
                {product.minimumStockQuantity}
              </TableCell>

              {/* <TableCell>
                <Chip
                  label={product.isFree ? "Yes" : "No"}
                  color={product.isFree ? "success" : "default"}
                  size="small"
                />
              </TableCell> */}

              {/* <TableCell sx={{ color: "text.secondary" }}>
                {dayjs(product.updatedAt).format("DD MMM, YYYY")}
              </TableCell> */}
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}
